var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLadyBgpath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 687.173,
    height: 686.734,
    viewBox: "0 0 687.173 686.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lady_bgpath",
    transform: "translate(-1030.323 -215.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M227.26,1.3c64.789-14.575,96.459,96.69,118.219,165.909S473.7,256.967,449.309,368.294s-215.735,70.519-215.735,70.519S50.806,453.976,7.554,368.294,120.2,176.462,136.173,146.388,162.471,15.876,227.26,1.3Z",
    transform: "translate(1135.313 766.684) rotate(-90)",
    fill: "#1889e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M239.308,1.37c68.224-15.348,101.573,101.816,124.486,174.7s135.022,94.516,109.334,211.744S247.5,494.472,247.5,494.472,53.5,478.042,7.954,387.818s118.619-202,135.438-233.67S171.084,16.718,239.308,1.37Z",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 1030.323, 559.048)",
    fill: "#f9c51a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadyBgpath);
export default __webpack_public_path__ + "static/media/lady_bgpath.4675af55f41e4d63ca65cbc9160f9f7f.svg";
export { ForwardRef as ReactComponent };